import type { MouseEvent } from 'react';

export const tableShellClasses = 'overflow-x-auto';

export const tableClasses = 'min-w-full divide-y divide-subtle';

export const tableHeaderCellClasses =
  'px-4 py-2.5 text-left text-xs font-medium text-neutral-500';

export const tableRowClasses =
  'transition-colors duration-150 ease hover:bg-neutral-50';

export const tableRowClickableClasses =
  'transition-colors duration-150 ease hover:bg-neutral-50 active:bg-neutral-100 cursor-pointer';

export const tableCellClasses =
  'px-4 py-2.5 whitespace-nowrap text-sm text-neutral-700';

export const tableMenuItemClasses =
  'block w-full rounded-md px-2 py-1 text-[13px] font-medium text-left text-neutral-700 transition-colors duration-150 ease hover:bg-neutral-100 hover:text-neutral-900';

export const tableMenuItemActiveClasses = 'bg-neutral-100 text-neutral-900';

/** Navigate on row click; skip modifier keys and interactive child elements. */
export function handleTableRowClick(
  e: MouseEvent,
  href: string,
  push: (url: string) => void
) {
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  if ((e.target as HTMLElement).closest('a,button')) return;
  push(href);
}
